import { render, staticRenderFns } from "./ArticleListItem.vue?vue&type=template&id=3bbae845&scoped=true&"
import script from "./ArticleListItem.vue?vue&type=script&lang=js&"
export * from "./ArticleListItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListItem.vue?vue&type=style&index=0&id=3bbae845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbae845",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ArticleListItem.vue
// module id = 46
// module chunks = 0